import classNames from 'classnames/bind';

import styles from '../RenderCell.module.css';
const stylesContext = classNames.bind(styles);

interface MonetaryAmountCell {
	value?: number | null;
	defaultValue?: number;
	className?: string;
}

/**
 *
 */
export default function MonetaryAmountCell({ value, defaultValue = 0, ...props }: MonetaryAmountCell) {
	const cellStyles = stylesContext({
		[props.className ?? '']: Boolean(props.className),
		money: true,
		negative: value && value < 0
	});

	return (
		<div className={cellStyles}>
			<span>$</span>{' '}
			<span>
				{value?.toLocaleString(undefined, {
					minimumFractionDigits: 2
				}) ??
					defaultValue.toLocaleString(undefined, {
						minimumFractionDigits: 2
					})}
			</span>
		</div>
	);
}
